import { Injectable, TemplateRef } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {
  toasts: any[] = [];

  constructor(private snackBar: MatSnackBar) {}

  /**
   * Méthode pour afficher un toast avec du texte ou un template
   * @param textOrTpl - Le texte ou TemplateRef à afficher dans le toast
   * @param options - Options supplémentaires (className, délai, etc.)
   */
  show(
    textOrTpl: string | TemplateRef<any>,
    options: { [key: string]: any } = {}
  ) {
    this.toasts.push({ textOrTpl, ...options });
  }

  /**
   * Méthode pour supprimer un toast de la liste
   * @param toast - Le toast à supprimer
   */
  remove(toast: any) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  /**
   * Méthode pour afficher un toast d'erreur
   * @param title - Le titre du toast
   * @param message - Le message d'erreur à afficher
   * @param delay - Délai avant que le toast se ferme (optionnel)
   */
  error(title: string, message: string, delay: number = 2000) {
    this.show(message, {
      classname: 'bg-danger text-light error',
      delay,
      autohide: true,
      headertext: title,
    });
  }

  /**
   * Méthode pour afficher un toast de succès
   * @param title - Le titre du toast
   * @param message - Le message de succès à afficher
   * @param delay - Délai avant que le toast se ferme (optionnel)
   */
  success(title: string, message: string, delay: number = 2000) {
    this.show(message, {
      classname: 'bg-success text-light success',
      delay,
      autohide: true,
      headertext: title,
    });
  }

  showNotification(message: string, type: 'success' | 'error' = 'success') {
    const config = new MatSnackBarConfig();
    config.duration = 3000;
    
    // Utilisation des classes personnalisées
    config.panelClass = [`custom-snackbar-${type}`];
    
    config.verticalPosition = 'top';
    config.horizontalPosition = 'right';
    
    this.snackBar.open(message, 'Fermer', config);
  }

  // showNotification(message: string, type: 'success' | 'error' = 'success') {
  //   const config = new MatSnackBarConfig();
  //   config.duration = 3000;
    
  //   // Change to use type-specific class names
  //   config.panelClass = [`custom-snackbar-${type}`];
    
  //   config.verticalPosition = 'top';
  //   config.horizontalPosition = 'right';
    
  //   this.snackBar.open(message, 'Fermer', config);
  // }

// showNotification(message: string, type: 'success' | 'error' = 'success') {
//     const config = new MatSnackBarConfig();
//     config.duration = 3000;
//     config.panelClass = ['custom-snackbar', type === 'success' ? 'success' : 'error'];
    
//     // Configuration spécifique pour le positionnement absolu
//     config.verticalPosition = 'top';
//     config.horizontalPosition = 'right';
    
//     this.snackBar.open(message, 'Fermer', config);
//   }

  formatMsgServeur(msg: any) {
    var messageError = msg;

    if (
      msg == "Operation effectuee avec succes" ||
      msg == "Operation effectuee avec succes:"
    ) {
      msg = "Opération effectuée avec succès.";
      return msg;
    }

    if (msg) {
      messageError = messageError.replace(
        "Operation effectuee avec succes:",
        "Opération effectuée avec succès."
      );
      messageError = messageError.replace(
        "Impossible de se connecter a la base de donnees:",
        ""
      );
      messageError = messageError.replace(
        "La base de donnees est indisponible:",
        ""
      );
      messageError = messageError.replace(
        "Permission refusee par la base de donnees:",
        ""
      );
      messageError = messageError.replace(
        "Le serveur de base de donnees a refuse la requete:",
        ""
      );
      messageError = messageError.replace("Authentification echouee:", "");
      messageError = messageError.replace("Donnee existante:", "");
      messageError = messageError.replace(
        "Liste vide : il n'y a pas de donnees respectant ce critere:",
        ""
      );
      messageError = messageError.replace(
        "il n'y a pas de donnees respectant ce critere",
        ""
      );
      messageError = messageError.replace("Champ non renseigne:", "");
      messageError = messageError.replace("Utilisateur deja connecte:", "");
      messageError = messageError.replace(
        "la requete attendue n'est pas celle fournie:",
        ""
      );
      messageError = messageError.replace("Le type est incorrect:", "");
      messageError = messageError.replace(
        "Le format de la date est incorrect:",
        ""
      );
      messageError = messageError.replace(
        "le serveur a signale un format invalide:",
        ""
      );
      messageError = messageError.replace(
        "le code de la langue n'est pas valide:",
        ""
      );
      messageError = messageError.replace(
        "La periode de date n'est pas valide",
        ""
      );
      messageError = messageError.replace(
        "une erreur est survenue lors de l'enregistrement:",
        ""
      );
      messageError = messageError.replace(
        "le name de l'entite n'est pas valide:",
        ""
      );
      messageError = messageError.replace(
        "Veuillez renseigner une seule valeur pour cette donnee:",
        ""
      );
      messageError = messageError.replace(
        "La somme des pourcentages ne doit exceder 100:",
        ""
      );
      messageError = messageError.replace(
        "Erreur de generation de fichier:",
        ""
      );
      messageError = messageError.replace(
        "login et/ou mot de passe incorrect(s):",
        ""
      );
      messageError = messageError.replace("Operation interdite/refusee:", "");
      messageError = messageError.replace(
        "cette donnees ne peut etre supprimee car elle est utilisee:",
        ""
      );
      messageError = messageError.replace(
        "cette donnees est trop superieure:",
        ""
      );
      messageError = messageError.replace(
        "Vous n'etes pas autoriser a effectuer cette operation.",
        ""
      );
      messageError = messageError.replace("Donnee inexistante:", "");
      messageError = messageError.replace("Erreur interne:", "");
      messageError = messageError.replace("Donnee(s) non trouvee(s):", "");
      messageError = messageError.replace(
        "Le serveur de base de donnees a refuse la requete:",
        ""
      );
      messageError = messageError.replace(
        "cette donnees ne peut etre supprimee car elle est utilisee:",
        ""
      );
      messageError = messageError.replace(
        "Vous n'etes pas autoriser a effectuer cette operation.",
        ""
      );
    }

    return messageError;
  }
  getMessageEndPointNotAvailble() {
    return "Connexion momentanément interrompue, veuillez réessayer ultérieurement !";
  }

  /**
   * Méthode pour afficher un toast d'alerte
   * @param title - Le titre de l'alerte
   * @param message - Le message d'alerte à afficher
   * @param delay - Délai avant que le toast se ferme (optionnel)
   */
  alert(title: string, message: string, delay: number = 2000) {
    this.show(message, {
      classname: 'bg-info text-light alert',
      delay,
      autohide: true,
      headertext: title,
    });
  }
}
